import React from "react";
import PropTypes from "prop-types";
import styles from "./StyleCount.css";
import classnames from "classnames/bind";

const combineClasses = classnames.bind(styles);

const StyleCount = ({ itemCount }, { formatTranslation, formatNumber }) => (
  <p
    data-auto-id="styleCount"
    className={combineClasses(styles.style, "styleCount")}
  >
    {formatTranslation("plp_web_style_count_noun", {
      smart_count: itemCount,
      formattedCount: formatNumber(itemCount)
    })}
  </p>
);

StyleCount.propTypes = {
  itemCount: PropTypes.number.isRequired
};

StyleCount.contextTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired
};

export default StyleCount;
